import authRouterPaths from './authRouterPaths';

export default authRouterPaths;
